import React from 'react';
import image3 from '../assets/1.webp';
import ScrollToBottomButton from '../components/ui/ScrollToBottomButton';

const experiences = [
  {
    title: 'Hillscape Views & Nature Vibes',
    description: 'Wake up to stunning panoramas of the rolling Himalayan foothills. Whether your room is Mall Road facing, Garden View, or Hill View, every glance out the window is picture-perfect. Perfect for sunrise lovers, nature photographers, and peace seekers.',
    image: process.env.PUBLIC_URL + '/hotel/IMG_9614.webp',
  },
  {
    title: 'Comfortable, Thoughtful Stays',
    description: 'Experience pure comfort with well-appointed rooms with modern amenities, soft linens, cozy décor, and serene ambiance, and a dedicated housekeeping & service team. Your room, your sanctuary.',
    image: process.env.PUBLIC_URL + '/rooms/01.webp',
  },
  {
    title: 'Relaxing Lounge & Common Areas',
    description: 'Unwind in our stylish common spaces with a warm lounge with seating, tea & coffee corners, and space to read, chat, or connect with fellow travelers.',
    image: '/hotel/DSC_0304.webp',
  },
  {
    title: 'Prime Location, Walk to Mall Road',
    description: 'Step outside & explore Mall Road shopping, local cafés & bakeries, and cultural shops & viewpoints. All just a short stroll away!',
    image: process.env.PUBLIC_URL + '/hotel/location.webp',
  },
  {
    title: 'Photogenic Corners Everywhere',
    description: 'Whether you love scenic hill sights, boutique interiors, or colorful local life, you’ll find your perfect shot here.',
    image: process.env.PUBLIC_URL + '/c.webp',
  },
  {
    title: 'Nearby Culinary Adventures',
    description: 'Though Pineridge operates on Room Only (E.P.), enjoy local Darjeeling-style momos & thukpas, cafés with mountain views, and rooftop dining experiences nearby. We’re happy to recommend places!',
    image: process.env.PUBLIC_URL + '/momo.webp',
  },
  {
    title: 'Curated Local Experiences',
    description: 'We help you plan sunrise & sunset viewpoints, Toy Train rides (Darjeeling Himalayan Railway), walks through local markets, and nature walks & short hikes. Bring your adventure spirit!',
    image: process.env.PUBLIC_URL + '/z.webp',
  },
  {
    title: 'Relaxation & Warm Hospitality',
    description: 'At Pineridge, it’s more than a stay, it’s comfort & care. Friendly staff, personalized attention, and smooth check-in & service support. Feel at home, while discovering Darjeeling.',
    image: process.env.PUBLIC_URL + '/231.webp',
  },
  {
    title: 'Why Guests Love Us?',
    description: 'Great views, an excellent location, clean and comfortable rooms, and warm, attentive service—Pineridge Hotel offers access to Darjeeling’s very best. From waking up to misty mountain views to stepping into the town’s vibrant culture, every stay becomes an experience. Discover thoughtfully curated moments designed to make your visit truly memorable.',
  },
  {
    title: 'Come Experience Darjeeling Differently',
    description: '',
  },
];

const Experiences = () => {
  return (
    <div className="bg-light-beige">
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${image3})` }}
        data-aos="fade-in"
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-aos="fade-up">Experiences at Pineridge</h1>
        </div>
        <ScrollToBottomButton targetId="experiences-content" />
      </section>

      <main id="experiences-content" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-16">
            {experiences.slice(0, experiences.length - 2).map((experience, index) => (
              <div
                key={index}
                className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
                data-aos="fade-up"
              >
                <div className="w-full md:w-1/2 overflow-hidden rounded-lg shadow-lg border border-beige">
                  <img
                    src={experience.image}
                    alt={experience.title}
                    className="h-full w-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <h2 className="text-3xl font-bold text-dark-green font-['Cormorant_Garamond',serif] mb-4">
                    {experience.title}
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    {experience.description}
                  </p>
                </div>
              </div>
            ))}
            {/* Render the last two experiences as paragraphs */}
            <div className="text-center mt-16" data-aos="fade-up">
              <h2 className="text-3xl font-bold text-dark-green font-['Cormorant_Garamond',serif] mb-4">
                {experiences[experiences.length - 2].title}
              </h2>
              <p className="text-gray-700 leading-relaxed max-w-3xl mx-auto">
                {experiences[experiences.length - 2].description}
              </p>
            </div>
            <div className="text-center mt-8" data-aos="fade-up">
              <p className="text-gray-700 text-xl font-semibold">
                {experiences[experiences.length - 1].title}
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Experiences;
